import { render, staticRenderFns } from "./type2.vue?vue&type=template&id=2869e966&scoped=true"
import script from "./type2.vue?vue&type=script&lang=js"
export * from "./type2.vue?vue&type=script&lang=js"
import style0 from "./type2.vue?vue&type=style&index=0&id=2869e966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2869e966",
  null
  
)

export default component.exports